import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class MigrationService {

  constructor(private http: HttpClient) { }

  selectEnv(env: string){
    return this.http.get(environment.apiUrl+"/migration/select-env?env="+env)
  }

  getCurrentEnv(){
    return this.http.get(environment.apiUrl+"/migration/current-env");
  }
}
